const  CardComponent = function(key) {
    return {
        number: '',
        birthdate : '',
        name: '',
        expires: '',
        cvv: '',
        cardBrand: '',
        errors: [],
        document : '',
        loading: false,
        key : key,
        removeError: function (input) {
            this.errors = this.errors.splice(this.errors.indexOf(input), 1);
        },
        showError: function (input, message) {
            this.errors[input] = message;
        },
        reset : function() {
            this.name = '';
            this.number = '';
            this.expires = '';
            this.cvv = '';
            this.birthdate = '';
            this.document = '';
        },
        submit: function (event) {
            event.preventDefault();
            const self = this;
            self.loading = true;
            self.errors = [];

            return new Promise(function (resolve, reject) {
                const  card = {
                    card_holder_name : self.name,
                    card_expiration_date : self.expires,
                    card_number : self.number,
                    card_cvv : self.cvv,
                }

                const cardValidations = window.pagarme.validate({card : card})

                if(cardValidations.card) {
                    const errors = Object.keys(cardValidations.card).filter(function (item) {
                        return cardValidations.card[item] === false;
                    }).reduce(function (items, item) {
                        items.push(item);
                        return items;
                    }, []);
                    if (errors.length > 0) {
                        return reject(errors);
                    }
                }

                window.pagarme.client.connect({ encryption_key: self.key})
                    .then(client => client.security.encrypt(card))
                    .then(card_hash => resolve(  resolve(card_hash)))

            }).then(function (data) {
                Livewire.emit( 'card-submit', data, self.document, self.birthdate );
            }).catch(function (errors) {
                if (errors instanceof Array) {
                    errors.forEach(function (error) {
                        self.showError(error, window.cardUtils.getErrorMessage(error));
                    })
                    self.loading = false;
                } else {
                    console.log(errors);
                }
            });
        },
    }
}
export default CardComponent